(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tt-cart-feedback"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tt-cart-feedback')) {
    customElements.define('tt-cart-feedback', class extends HTMLElement {
      connectedCallback() {
        if (this.onCartAdded) return;
        this.onCartAdded = () => {
          clearTimeout(this.showTimer);
          clearTimeout(this.hideTimer);
          const message = this.querySelector('span');
          message.textContent = '';
          this.showTimer = setTimeout(() => {
            message.textContent = this.dataset.message;
            this.classList.add('is-visible');
            this.hideTimer = setTimeout(() => this.classList.remove('is-visible'), 3500);
          }, 50);
        };
        document.addEventListener('tt:cart-added', this.onCartAdded);
      }
      disconnectedCallback() {
        document.removeEventListener('tt:cart-added', this.onCartAdded);
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
        this.onCartAdded = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tt-color-card-behavior"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tt-color-card')) {
    customElements.define('tt-color-card', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) { this.initGallery(); return; }
        this.bound = true;
        this.colorData = JSON.parse(this.querySelector('[data-tt-color-data]').textContent);
        this.details = this.querySelector('details');
        if (this.details) {
          this.details.addEventListener('toggle', () => {
            if (!this.details.open) return;
            document.querySelectorAll('tt-color-card details[open]').forEach(other => {
              if (other !== this.details) other.open = false;
            });
          });
        }
        this.addEventListener('change', event => {
          const select = event.target.closest('select[name="id"]');
          if (!select?.value) return;
          const color = this.colorData.colors.find(item => item.name === this.dataset.color);
          const variant = color?.variants.find(item => item.id === select.value);
          if (!variant) return;
          this.updatePrice(variant);
          this.syncLinks(variant.id);
          this.querySelector('input[name="quantity"]').value = variant.quantity;
        });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.details?.open) {
            this.details.open = false;
            this.details.querySelector('summary').focus();
          }
        });
        this.initGallery();
      }
      initGallery() {
        if (this.carousel || !this.isConnected) return;
        const gallery = this.querySelector('.tt-color-carousel');
        if (!gallery || gallery.querySelectorAll('.pro-media').length < 2) return;
        if (typeof Flickity === 'undefined') {
          this.onGalleryReady ||= () => this.initGallery();
          window.addEventListener('load', this.onGalleryReady, { once: true });
          return;
        }
        this.carousel = new Flickity(gallery, {
          cellSelector: '.pro-media',
          rightToLeft: getComputedStyle(this).direction === 'rtl',
          cellAlign: 'center',
          setGallerySize: false,
          wrapAround: true,
          draggable: true,
          dragThreshold: 8,
          pageDots: true,
          prevNextButtons: false,
          on: { change: index => {
            const cell = gallery.querySelectorAll('.pro-media')[index];
            if (cell) this.selectColor(cell.dataset.slideColor);
          } }
        });
      }
      selectColor(name) {
        if (name === this.dataset.color) return;
        const color = this.colorData.colors.find(item => item.name === name);
        if (!color) return;
        this.dataset.color = name;
        this.querySelector('.tt-color-name').textContent = name;
        const sizeRange = this.querySelector('[data-tt-size-range]');
        if (sizeRange) {
          sizeRange.hidden = !color.sizeRange;
          sizeRange.querySelector('bdi').textContent = color.sizeRange || '';
        }
        const available = color.variants.filter(variant => variant.available);
        const matching = available.filter(variant => variant.matched);
        const priced = [...(matching.length ? matching : available.length ? available : color.variants)].sort((a, b) => a.price - b.price);
        const variant = priced[0];
        this.updatePrice(variant, priced.some(item => item.price !== variant.price));
        this.syncLinks(variant.id);
        this.querySelector('[data-tt-availability-badge]').hidden = available.length > 0;
        if (!this.details) return;
        this.details.open = false;
        this.details.hidden = available.length === 0;
        const sizeFor = new DOMParser().parseFromString(color.sizeFor, 'text/html').body.textContent;
        this.details.querySelector('summary').setAttribute('aria-label', sizeFor);
        this.details.querySelector('label').textContent = `${name} · ${this.colorData.sizeLabel}`;
        const select = this.details.querySelector('select');
        select.setAttribute('aria-label', sizeFor);
        const placeholder = new Option(this.colorData.chooseSize, '', true, true);
        placeholder.disabled = true;
        const pricesVary = new Set(color.variants.map(item => item.price)).size > 1;
        const options = color.variants.map(item => {
          const label = item.size + (pricesVary ? ` — ${item.money}` : '') + (item.available ? '' : ` — ${this.colorData.soldOut}`);
          const option = new Option(label, item.id);
          option.disabled = !item.available;
          return option;
        });
        select.replaceChildren(placeholder, ...options);
        this.details.querySelector('input[name="quantity"]').value = variant.quantity;
        const error = this.details.querySelector('.product-form__error-message-wrapper');
        if (error) error.hidden = true;
      }
      updatePrice(variant, varies = false) {
        const onSale = variant.comparePrice > variant.price;
        this.querySelectorAll('[data-tt-price]').forEach(price => { price.textContent = varies ? variant.fromMoney : variant.money; });
        this.querySelector('[data-tt-compare]').textContent = variant.compare;
        this.querySelector('.tt-color-price').classList.toggle('price--on-sale', onSale);
        const badge = this.querySelector('[data-tt-sale-badge]');
        badge.hidden = !variant.available || !onSale;
        badge.textContent = variant.saleLabel;
      }
      syncLinks(id) {
        const url = new URL(this.dataset.productUrl, window.location.origin);
        url.searchParams.set('variant', id);
        this.querySelectorAll('[data-tt-product-link]').forEach(link => { link.href = url.pathname + url.search; });
      }
      disconnectedCallback() {
        this.carousel?.destroy();
        this.carousel = null;
        if (this.onGalleryReady) window.removeEventListener('load', this.onGalleryReady);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tt-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-tt-size-reference]');
    if (!link) return;
    const reference = link.closest('.tt-size-guide')?.querySelector('.tt-size-guide__reference');
    if (!reference) return;
    event.preventDefault();
    reference.open = true;
    reference.querySelector('summary').focus({ preventScroll: true });
    reference.closest('.tt-size-guide').scrollTo({
      top: reference.offsetTop - 12,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
    });
  });
  } catch(e) { console.error(e); }
})();

})();
